/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DiagLabInventoryCheckout from './diag-lab-inventory-checkout';
import DiagLabInventoryCheckoutDetail from './diag-lab-inventory-checkout-detail';
import DiagLabInventoryCheckoutUpdate from './diag-lab-inventory-checkout-update';
import DiagLabInventoryCheckoutDeleteDialog from './diag-lab-inventory-checkout-delete-dialog';

const DiagLabInventoryCheckoutRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DiagLabInventoryCheckout />} />
    <Route path="new" element={<DiagLabInventoryCheckoutUpdate />} />
    <Route path=":id">
      <Route index element={<DiagLabInventoryCheckoutDetail />} />
      <Route path="edit" element={<DiagLabInventoryCheckoutUpdate />} />
      <Route path="delete" element={<DiagLabInventoryCheckoutDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DiagLabInventoryCheckoutRoutes;
